module.exports = __webpack_public_path__ + "img/connect-2-zh-m.857a09f5.png";